import { render, staticRenderFns } from "./ContentLink.vue?vue&type=template&id=00881bca&scoped=true&"
import script from "./ContentLink.vue?vue&type=script&lang=js&"
export * from "./ContentLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00881bca",
  null
  
)

export default component.exports